import Vue from 'vue';

const hasPermission = {
    install(Vue,options) {
        //自定义指令v-has：
        Vue.directive('has', {
            //inserted：被绑定元素插入父节点时调用
            inserted: function (el, binding) {
                if (!Vue.prototype.$_has(binding.value)) {
                    
					el.parentNode.removeChild(el);
					
					
					
                }
            },
        });
        //权限检查方法
        Vue.prototype.$_has = function (value) {
			
            let isExist = false;
			// var perms = localStorage.getItem("perms");
			// if(perms.indexOf(value)>-1){
			// 	isExist = true;
			// }
            // return isExist;

            const permsStr = localStorage.getItem("perms");
  // 若未存储权限，直接返回 false
  if (!permsStr) return false;
  // 将字符串解析为数组（注意：存储时需确保是 JSON 格式，避免解析错误）
  const perms = JSON.parse(permsStr);
  // 用 includes 精确匹配数组中是否存在目标值
  return perms.includes(value);

        };
    }
};
export default hasPermission;